angular.module('filters').filter('ordinal', function() {
  return function(input) {
    var suffix, suffixes;
    if ((input == null) || isNaN(input)) {
      return input;
    }
    if (input % 100 >= 11 && input % 100 <= 13) {
      return `${input}th`;
    }
    suffixes = ["th", "st", "nd", "rd"];
    suffix = suffixes[input % 10] || "th";
    return `${input}${suffix}`;
  };
});
